import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import {
    STYLES,
    STYLE_GRADIENT,
    STYLE_PROGRESS,
    STYLE_CONFIG,
    TYPES,
    TYPE_INDETERMINATE,
    TYPE_DETERMINATE,
} from './constants';

import { getStyleByProgress } from './utils';

import styles from './Linear.module.scss';

const Indeterminate = ({ style, stopColor1, railColor, className }) => {
    const indicatorStyles = {
        backgroundColor: stopColor1,
    };
    const railStyles = {
        backgroundColor: railColor,
    };

    const innerClassName = classNames(styles.line, styles.indeterminateLine, {
        [styles.uiOrangeBackgroundColor]: style === STYLE_GRADIENT,
    });

    const intl = useIntl();

    return (
        <div
            data-testid="linear-indeterminate"
            className={classNames(styles.rail, className)}
            style={railStyles}
            aria-valuetext={intl.formatMessage({
                id: 'In progress',
                defaultMessage: 'In progress',
            })}
        >
            <div className={innerClassName} style={indicatorStyles} />
        </div>
    );
};

const Determinate = ({ style, stopColor1, railColor, progress, className }) => {
    const indicatorStyles = {
        width: `${progress}%`,
        backgroundColor: stopColor1,
    };
    const railStyles = {
        backgroundColor: railColor,
    };

    const innerClassName = classNames(styles.line, styles.determinateLine, {
        [styles.vibrantGreenBackgroundColor]: style === STYLE_GRADIENT,
    });

    return (
        <div
            data-testid="linear-determinate"
            className={classNames(styles.rail, className)}
            style={railStyles}
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label="progressbar"
        >
            <div className={innerClassName} style={indicatorStyles} />
        </div>
    );
};

const PROGRESS_INDICATOR_TYPE_MAP = {
    [TYPE_INDETERMINATE]: Indeterminate,
    [TYPE_DETERMINATE]: Determinate,
};

export class Linear extends React.PureComponent {
    static propTypes = {
        /**
         * Type of indicator for the loader (indeterminate | determinate)
         */
        type: PropTypes.oneOf(TYPES),

        /**
         * Color of the loader (dark | light | gradient)
         */
        style: PropTypes.oneOf(STYLES),

        /**
         * Progress bar if the chosen Type is determinate
         */
        progress: PropTypes.number,

        className: PropTypes.object,
    };

    render() {
        const { style, type, progress, className } = this.props;

        const { stopColor1, stopColor2, railColor } =
            style === STYLE_PROGRESS ? getStyleByProgress(progress) : STYLE_CONFIG[style];

        const Component = PROGRESS_INDICATOR_TYPE_MAP[type];

        return (
            <Component
                style={style}
                stopColor1={stopColor1}
                stopColor2={stopColor2}
                railColor={railColor}
                progress={progress}
                className={className}
            />
        );
    }
}
